import React from 'react'

const EmptyRow = ({ label }: { label: string }) => {
  return (
    <p className="tw-text-xs tw-text-muted-foreground tw-italic tw-px-2 tw-py-3">No {label}.</p>
  )
}

export default EmptyRow